import $ from 'jquery';
import 'jquery-ui/ui/core';
export async function offerGallerySlider() {
    // await import('slick-slider');
    // $('.js-offer-gallery').slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: false,
    //     fade: true,
    //     asNavFor: '.js-offer-gallery-navigation'
    // });


    const {Gallery} = await import('../gallery')
    new Gallery({
        offerGalleryId: '#offerGallery',
        offerGalleryImages: '.offer-gallery-main',
        modalId: '#offerGalleryModal',
        modalGalleryId: '#modalGallery'
    })
}